/**
 * Parcels Details
 */

// React
import React, { useState, useEffect, useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';

// Context
import AuthContext from '../../authContext';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import theme from '../../theme';
import {
  Typography,
  Paper,
  Grid,
  Button,
  Divider,
  CircularProgress,
  Box,
  ClickAwayListener,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  DialogTitle,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiKeyOutline,
  mdiArrowRight,
  mdiPrinter,
  mdiArchiveOutline,
  mdiClose,
  mdiChevronLeft,
  mdiCheck,
  mdiHomeOutline,
} from '@mdi/js';

// Components
import ListParcelItems from './listMob';
import Modal from '../../components/Modal';

// Helper
import {
  removeEmptyValueObject,
  translate,
} from '../../utils/helpers';

// Type
import { Props } from './interfaces';
import Pagination from '@material-ui/lab/Pagination';
import RenderFilter, { Filter } from '../../utils/listDaynamicFilter';
import clsx from 'clsx';
import parcelItemsRepository from 'client-sdk/src/Repository/parcel-items-repository';
import inventoryItemsRepository from 'client-sdk/src/Repository/inventory-items-repository';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotification';
import { Tabs } from '@material-ui/core';
import { Tab } from '@material-ui/core';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {

    },
    paper: {
      backgroundColor: 'white',
      marginTop: '40px',
      marginBottom: '16px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    title: {
      fontWeight: 500,
    },
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '70%',
      marginTop: '30px',
      top: '180px',
      right: '33px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '12px',
      fontWeight: 500,

    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      marginTop: '24px',
      fontSize: '12px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    collapseIcon: {
      marginTop: '-36px',
      textAlign: 'center',
      position: 'relative',
      width: '100%',
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '40px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: theme.palette.secondary.main,
        border: '5px solid white',
      },
    },
    tileBar: {
      zIndex: 10,
      position: 'fixed',
      top: '0px',
      right: '0px',
      display: 'flex',
      width: '100%',
      padding: '8px',
      justifyContent: 'center',
      borderRadius: '0',
      border: 'none'
    },
    tabs: {
      zIndex: 12,
      boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.08)',
      position: 'fixed',
      top: '52px',
      right: 0,
      borderBottom: 1,
      borderColor: '#000',
      width: '100%',
      backgroundColor: '#fff',

    },
    detail: {
      backgroundColor: 'white',
      padding: '5px',
      width: '100%',
    },
    btnBottom: {
      flexDirection: 'row',
      position: 'fixed',
      width: '100%',
      backgroundColor: '#fff',
      bottom: '0',
      right: '0',
      padding: '15px 10px',
      zIndex: 2,
      borderTop: '1px solid lightgray',
    }
  })
);

export function Details(props: Props) {
  const authContext = useContext(AuthContext);
  const [filters, setFilters] = useState([] as Filter[]);
  const history = useHistory();
  const [filtersValues, setFiltersValues] = useState({
    parcelId: { equals: props.match.params.id },
    page: 0,
    size: 1000,
  } as any);
  const [open, setOpen] = React.useState(false);
  const [openDeleteItem, setOpenDeleteItem] = React.useState(false);
  const [parcelItemHasConflict, setParcelItemHasConflict] = React.useState(
    false
  );
  const [error, setError] = useState('');
  const [description, setDescription] = useState('');
  const [inventoryItemsError, setInventoryItemsError] = useState('');
  const [
    inventoryItemsWithSerialError,
    setInventoryItemsWithSerialError,
  ] = useState('');
  const [openHandleChangeStatus, setOpenHandleChangeStatus] = React.useState(
    false
  );
  const [openHandleConflict, setOpenHandleConflict] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [inventoryItemsLoading, setInventoryItemsLoading] = useState(false);
  const [
    inventoryItemsWithSerialLoading,
    setInventoryItemsWithSerialLoading,
  ] = useState(false);
  const [parcelItem, setParcelItem] = useState({} as any);
  const [item, setItem] = useState({} as any);
  const [productName, setProductName] = useState('');
  const [inventoryItems, setInventoryItems] = useState([]);
  const [inventoryItemsWithSerial, setInventoryItemsWithSerial] = useState([]);
  const [inventoryItemsCount, setInventoryItemsCount] = useState(0);
  const [printModal, setPrintModal] = useState(false as boolean);
  const [openFilterBox, setOpenFilterBox] = React.useState(false);
  const [selected, setSelected] = React.useState<string[]>([]);
  const classes = useStyles();
  const [values, setValues] = useState(0);


  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'productName.contains',
        label: 'نام کالا',
        icon: mdiArchiveOutline,
      },
      {
        type: 'input',
        id: 'productCode.contains',
        label: 'کد کالا',
        icon: mdiKeyOutline,
      },
      {
        type: 'number',
        id: 'productId.equals',
        label: 'شناسه کالا',
        icon: mdiKeyOutline,
      },
      {
        type: 'number',
        id: 'skuId.equals',
        label: 'شناسه تنوع کالا',
        icon: mdiKeyOutline,
      },
      {
        type: 'input',
        id: 'skuCode.contains',
        label: 'کد تنوع کالا',
        icon: mdiKeyOutline,
      },
      {
        type: 'input',
        id: 'serialNumber.equals',
        label: 'سریال کالا',
        icon: mdiKeyOutline,
      },
    ]);
  };
  const getParcelItemWithId = async (id: any) => {
    const payload = { id };
    try {
      setLoading(true);
      const { response } = await parcelItemsRepository.getParcelItemsWithId({
        payload,
      });
      setParcelItem(response.data);
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  const closeUpdateParcelItem = () => {
    setOpenHandleChangeStatus(false);
  };

  const closeConflictParcelItem = () => {
    setOpenHandleConflict(false);
  };

  const updateParcelItemStatus = async (status: string = '') => {
    const { id } = props.match.params;
    const payload = {
      id: parcelItem.id,
      body: status
        ? status
        : parcelItem.status === 'UNLOADED'
          ? 'NOT_REGISTERED'.replace(/'/g, '"')
          : 'UNLOADED'.replace(/'/g, '"'),
      callback: () => {
        getParcelItemWithId(id);
        setOpenHandleChangeStatus(false);
        history.push(`/parcel/${parcelItem.parcelId}/unload-inventory-items`);
      },
    };
    try {
      setLoading(true);
      const callback = await parcelItemsRepository.updateParcelItemsStatus({
        payload,
      });
      handleNotfication(
        'تغییر وضعیت آیتم محموله با موفقیت انجام شد',
        'success'
      );
      callback && callback();
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseDialog = () => {
    setOpenDeleteItem(false);
  };

  const handleDeleteInventoryItems = (item: any) => {
    setItem(item);
    setOpenDeleteItem(true);
  };

  const deleteInventoryItem = async () => {
    const { id } = props.match.params;
    const payload = {
      id: item.id,
      body: { description: description },
      callback: () => {
        getParcelItemWithId(id);
        setOpenDeleteItem(false);
      },
    };
    try {
      setLoading(true);
      const callback = await inventoryItemsRepository.deleteByOperatorInventoryItems(
        {
          payload,
        }
      );
      handleNotfication('وضعیت آیتم مورد نظر با موفقیت تغییر کرد ', 'success');
      callback && callback();
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  const clearnParcelInventoryItems = () => {
    setInventoryItemsError('');
    setInventoryItemsCount(0);
    setInventoryItems([]);
  };
  const getInventoryItemsWithSerial = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsWithSerialLoading(true);
      const {
        response,
        callback,
      } = await inventoryItemsRepository.getInventoryItemsWithSerial(
        { payload },
        payload.callback
      );
      if (callback) {
        callback();
      }
      setInventoryItemsWithSerial(response.data.content);
      if (response.data.content.length === 0)
        handleNotfication('هیچ آیتمی پیدا نشد.', 'warn');
    } catch (error) {
      setInventoryItemsWithSerialError(error.message);
      handleError(error.response);
    } finally {
      setInventoryItemsWithSerialLoading(false);
    }
  };
  useEffect(() => {
    if (parcelItem.inventoryItems) {
      const conflictedItems = parcelItem.inventoryItems.filter(
        (item: any) => item.status === 'DELETED_BY_OPERATOR'
      );
      if (conflictedItems.length) {
        setParcelItemHasConflict(true);
      }
    }
  }, [parcelItem]);

  useEffect(() => {
    const { id } = props.match.params;
    getParcelItemWithId(id);
    return () => {
      clearnParcelInventoryItems();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  // useEffect(() => {
  //   const {id} = props.match.params;
  //   props.getParcelItemWithIdActionDispatch(id);
  //   props.getInventoryItemsWithSerialActionDispatch({
  //     ...filtersValues,
  //   });
  //   return () => {
  //     props.clearnParcelInventoryItemsDispatch();
  //   };
  // }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const getParcelInventoryItem = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsLoading(true);
      const {
        response,
        callback,
      } = await inventoryItemsRepository.getParcelInventoryItems({ payload });
      if (callback) {
        callback();
      }
      setInventoryItems(response.data.content);
      setInventoryItemsCount(response.data.totalElements);
    } catch (error) {
      setInventoryItemsError(error.message);
      handleError(error.response);
    } finally {
      setInventoryItemsLoading(false);
    }
  };
  useEffect(() => {
    if (parcelItem?.id) {
      let variantName = parcelItem.productName;
      for (let i = 0; i <= 2 && parcelItem.featureAndValues[i]; i++) {
        variantName = variantName.concat(
          ' - ',
          parcelItem.featureAndValues[i].key,
          ' : ',
          parcelItem.featureAndValues[i].value
        );
      }

      if (parcelItem.sellerName || parcelItem.providerName) {
        const sellerName = parcelItem.sellerName ?? parcelItem.providerName;
        variantName = variantName.concat(' ( ', sellerName, ' )');
      }
      setProductName(variantName);
    }
  }, [parcelItem]);

  useEffect(() => {
    setupFilters();
  }, [filtersValues]);

  const handleCollapse = () => {
    setOpen(!open);
  };

  const handleClickFilter = () => {
    setOpenFilterBox(prev => !prev);
  };

  useEffect(() => {
    setFiltersValues({
      parcelId: { equals: props.match.params.id },
      page: 0,
      size: 10000,
    });
  }, [printModal]);

  const handleClickAway = (e: any) => {
    // TODO: Shet
    if (
      e.target.getAttribute('dir') !== 'rtl' &&
      e.target.getAttribute('type') !== 'checkbox' &&
      e.target.getAttribute('class') !== 'PrivateSwitchBase-input-73' &&
      e.target.getAttribute('class') !==
      'MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock' &&
      e.target.getAttribute('aria-hidden') !== 'true'
    )
      setOpenFilterBox(false);
  };

  const handleOpenPrintModal = () => {
    setPrintModal(true);
  };

  const handleClosePrintModal = () => {
    setPrintModal(false);
  };

  const handleClick = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = inventoryItems.map((n: any) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClickPrint = () => {
    props.history.push(
      `/print-labels/${props.match.params.id}?items=${selected.join(',')}`
    );
  };

  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValues(newValue);
  };

  const TabPanel = (props: any) => {
    const { children, values, index, ...other } = props;

    return (

      <div
        role="tabpanel"
        hidden={values !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {values === index && <Box>{children}</Box>}
      </div>
    );
  };

  return (
    <div className={classes.root}>
      <Grid container>
        <Paper
          className={classes.tileBar}
        >
          <Button
            aria-label="details"
            size="medium"
            onClick={() => window.history.back()}
          >
            <Icon path={mdiArrowRight} size={1} className={classes.icon} />

          </Button>
          <Grid container xs={12} style={{ justifyContent: 'center', alignItems: 'center' }}>
            <Typography variant="h6" component="h6">
              {`
        جزيیات آیتم محموله 
        `}
            </Typography>
            <span className={classes.contentlabelTitle} style={{ marginRight: '8px' }}>{parcelItem.id}</span>


          </Grid>
          <span >
            <Link to={'/mobile-home'} style={{ justifySelf: 'right' }}>
              <Icon path={mdiHomeOutline} size={1.2} color={'black'} />
            </Link>
          </span>
        </Paper>
      </Grid>
      <Box className={classes.tabs}>
        <Tabs
          values={values}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="fullWidth"
        >
          <Tab label={"آیتم های انبار"} {...a11yProps(0)} />
          <Tab label=" جزییات آیتم" {...a11yProps(1)} />
        </Tabs>
      </Box>

      <TabPanel values={values} index={0}>
        <Grid item xs={12} style={{ marginTop: '40px' }}>
          {loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            parcelItem?.inventoryItems && (
              <>
                <ListParcelItems
                  data={parcelItem.inventoryItems}
                  parcelId={parcelItem.parcelId}
                  deleteInventoryItem={(item: any) =>
                    handleDeleteInventoryItems(item)
                  }
                />
              </>
            )
          )}
        </Grid>
        <Grid xs={12} style={{ position: 'fixed', bottom: '10px', left: 0, padding: '8px' }} container >
          <Divider style={{ marginBottom: '16px', width: '100%' }} />
          {parcelItemHasConflict && parcelItem.status !== 'CONFLICTED' ? (
            <Button
              fullWidth
              aria-label="unload-parcel"
              onClick={() => setOpenHandleConflict(true)}
              variant="contained"
              color="primary"
            >
              <span className="">مغایرت</span>
              <Icon path={mdiChevronLeft} size={1} />
            </Button>
          ) : (
            <Button
              fullWidth
              aria-label="unload-parcel"
              onClick={() => setOpenHandleChangeStatus(true)}
              variant="contained"
              color="primary"
            >
              <span className="">
                {parcelItem.status === 'UNLOADED'
                  ? 'بازگشت به کنترل نشده'
                  : 'کنترل شد'}
              </span>
              <Icon path={mdiChevronLeft} size={1} />
            </Button>
          )}
        </Grid>
      </TabPanel>
      <TabPanel values={values} index={1}>

        <div className={classes.paper} >
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={9}>
              <div className={classes.item}>
                <span className={classes.label}>

                  {'نام کالا:  '}
                </span>
                <span>{productName}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={3}>
              <div className={classes.item}>
                <span className={classes.label}>
                  {'وضعیت:  '}
                </span>
                <span>{translate(parcelItem?.status, 'parcel')}</span>
              </div>
            </Grid>
            <Divider className={classes.divider} />
            <Grid item xs={12} sm={3}>
              <div className={classes.item}>
                <span className={classes.label}>
                  {'شناسه محموله:  '}
                </span>
                <span>{parcelItem.parcelId}</span>
              </div>
            </Grid>

            <Grid item xs={12} sm={3}>
              <div className={classes.item}>
                <span className={classes.label}>

                  {'کد کالا:  '}
                </span>

                <span>{parcelItem.productCode}</span>
              </div>
            </Grid>

            <Grid item xs={12} sm={3}>
              <div className={classes.item}>
                <span className={classes.label}>
                  {'کد تنوع کالا:  '}
                </span>

                <span>{parcelItem.variantCode}</span>
              </div>
            </Grid>

            <Grid item xs={12} sm={3}>
              <div className={classes.item}>
                <span className={classes.label}>
                  {'شناسه تنوع کالا:  '}
                </span>
                <span>{parcelItem.skuId}</span>
              </div>
            </Grid>
            <Divider className={classes.divider} />

            <Grid style={{ margin: 0 }} xs={12} container spacing={3}>
              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {'تعداد:  '}
                  </span>

                  <span>{parcelItem.count}</span>
                </div>
              </Grid>

              <Grid item xs={12} sm={3}>
                <div className={classes.item}>
                  <span className={classes.label}>
                    {'تعداد آیتم:  '}
                  </span>
                  <span>{parcelItem?.inventoryItems?.length}</span>
                </div>
              </Grid>


            </Grid>
          </Grid>
        </div>
      </TabPanel>



      <Dialog fullWidth
        open={openDeleteItem} onClose={handleCloseDialog}>
        <DialogContent >
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              zIndex: 10,
            }}
          >
            {handleCloseDialog ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDialog}
              >
                <Icon path={mdiClose} size={.8} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.cancelTitle}>

            ایا از حذف آیتم انبار با شناسه
            <strong> {item.id} </strong>و با نام کالای{' '}
            <strong>"{item?.productName}"</strong> اطمینان دارید ؟
          </div>

          <Grid container item xs={12} alignItems="flex-end">
            <div className={classes.item} style={{ width: '100%' }}>
              <span style={{ width: '100%' }}>
                <TextField
                  variant='outlined'
                  fullWidth
                  id="description"
                  name="description"
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  label="توضیحات"
                  size='small'
                />
              </span>
            </div>
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions style={{ padding: '8px 16px' }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button
                onClick={deleteInventoryItem}
                variant="contained"
                color="primary"
                size="medium"
                fullWidth
                disabled={loading || !description}
              >
                {`حذف آیتم`}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={handleCloseDialog}
                variant="outlined"
                color="primary"

                fullWidth
                autoFocus
                size="medium"
              >
                {`انصراف`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        open={openHandleChangeStatus}
        onClose={closeUpdateParcelItem}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              zIndex: 10,
            }}
          >
            {closeUpdateParcelItem ? (
              <IconButton aria-label="close" onClick={closeUpdateParcelItem}>
                <Icon path={mdiClose} size={.8} />
              </IconButton>
            ) : null}
          </div>

          <div className={classes.cancelTitle}>
            {` از 
            تغییر وضعیت آیتم محموله با شناسه
             "${parcelItem.id}"
             به 
             "${parcelItem.status === 'UNLOADED' ? 'تخلیه نشده' : 'تخلیه شده'}"
          مطمئن هستید؟`}
          </div>
        </DialogTitle>
        <Divider />
        <DialogActions style={{ padding: '8px 16px' }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>

              <Button
                onClick={e => updateParcelItemStatus()}
                fullWidth
                variant="contained"
                size="medium"
                color='primary'
              >
                {'بله'}
              </Button>
            </Grid>

            <Grid item xs={6}>
              <Button
                fullWidth
                autoFocus
                onClick={closeUpdateParcelItem}
                variant="outlined"
                color="primary"
                size="medium"
              >
                {'انصراف'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        open={openHandleConflict}
        onClose={closeConflictParcelItem}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              top: '5px',
              left: '5px',
              zIndex: 10,
            }}
          >
            {closeConflictParcelItem ? (
              <IconButton aria-label="close" onClick={closeConflictParcelItem}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
          </div>
          <div className={classes.cancelTitle}>
            {` از 
            تغییر وضعیت آیتم محموله با شناسه
             "${parcelItem.id}"
             به 
             "مغایرت"
          مطمئن هستید؟`}
          </div>
        </DialogTitle>
        <Divider />
        <DialogActions style={{ padding: '8px 16px' }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>

              <Button
                onClick={e => updateParcelItemStatus('CONFLICTED')}
                fullWidth
                variant="contained"
                size="medium"
                color="primary"

              >
                {'مغایرت'}
              </Button>
            </Grid>

            <Grid item xs={6}>
              <Button
                fullWidth
                autoFocus
                onClick={closeConflictParcelItem}
                variant="outlined"
                color="primary"
                size="medium"
              >
                {'انصراف'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Modal
        maxWidth="xl"
        onClose={handleClosePrintModal}
        open={printModal}
        title={
          <div style={{ textAlign: 'center' }}>
            <Icon path={mdiPrinter} size={4} color={theme.palette.green.main} />
          </div>
        }
        content={
          <Grid container>
            <Grid
              container
              justify="flex-end"
              item
              xs={12}
              style={{ marginBottom: '5px' }}
            >
              <ClickAwayListener onClickAway={handleClickAway}>
                <div>
                  <Button
                    type="button"
                    onClick={handleClickFilter}
                    className={classes.iconButton}
                    aria-label="search"
                  >
                    {openFilterBox ? 'بستن' : 'جستجوی پیشرفته'}
                  </Button>
                  {openFilterBox ? (
                    <div
                      className={clsx(classes.filterBox, {
                        [classes.filterOpen]: openFilterBox,
                      })}
                    >
                      <RenderFilter
                        filters={filters}
                        onFilter={(filtervalues: any) => {
                          setFiltersValues({
                            ...removeEmptyValueObject(filtervalues),
                            parcelId: { equals: props.match.params.id },
                            page: 0,
                            size: 100,
                          });
                          setOpenFilterBox(false);
                        }}
                        setOpenFilterBox={setOpenFilterBox}
                      />
                    </div>
                  ) : null}
                </div>
              </ClickAwayListener>
            </Grid>
            <Box mb={4} />
            <Grid xs={12} container justify="space-between" alignItems="center">
              <Pagination
                count={Math.ceil(inventoryItemsCount / filtersValues.size)}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
            </Grid>
          </Grid>
        }
      />
    </div>
  );
}

export default Details;
